import { FilterGroup } from '@teetsh/app/src/types/eleves';
import { FilterGroupAPI } from '@teetsh/app/src/queries/eleves/views/types';

export default function serializeFilter(filters: FilterGroup): FilterGroupAPI {
  return {
    filterSet: filters.filterSet.map(f => ({
      operator: f.operator,
      id: f.id,
      value: f.value,
      columnId: f.columnId,
    })),
    id: filters.id,
    conjunction: 'AND',
  };
}
